export default __webpack_public_path__ + "static/media/icons8-profit.b36124b9.svg";